import {
  hasSupportSession,
  openSupport,
  recentSupportError,
} from "@/lib/supportContext";
import { Button } from "./ui/button";

export function ReportProblemButton({ message }: { message?: string }) {
  if (
    !hasSupportSession() ||
    message?.includes("Mario je automatski obaviješten")
  )
    return null;
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      onClick={() =>
        openSupport(
          message
            ? {
                ...(recentSupportError() ?? {
                  status: null,
                  endpoint: "",
                  request_id: null,
                  occurred_at: new Date().toISOString(),
                }),
                message,
              }
            : (recentSupportError() ?? undefined),
        )
      }
    >
      💬 Prijavi ovo
    </Button>
  );
}
